import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

import { HeaderComponent } from '@layout/header/header.component';
import { FooterComponent } from '@layout/footer/footer.component';
import { TrialBannerComponent } from '@layout/trial-banner/trial-banner.component';

@Component({
  selector: 'app-marketing-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, TrialBannerComponent],
  template: `
    <app-trial-banner />
    <app-header />
    <main>
      <router-outlet />
    </main>
    <app-footer />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingLayoutComponent {
  constructor() {
    const router = inject(Router);
    const destroyRef = inject(DestroyRef);
    const subscription = router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      });
    destroyRef.onDestroy(() => subscription.unsubscribe());
  }
}
